import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { ConfirmPopoverComponent } from './confirm-popover.component';

@NgModule({
  imports: [SharedModule, OverlayModule],
  declarations: [ConfirmPopoverComponent],
  exports: [ConfirmPopoverComponent],
})
export class ConfirmPopoverModule {}
